export const inventoryTranslations = {
  // Page title and description
  items: "รายการสินค้า",
  manageInventoryItems: "จัดการรายการสินค้าคงคลังของคุณ",
  
  // Actions
  newItem: "สินค้าใหม่",
  
  // States
  loadingItems: "กำลังโหลดรายการสินค้า...",
  errorLoadingItems: "เกิดข้อผิดพลาดในการโหลดรายการสินค้า",
  unknownError: "ข้อผิดพลาดที่ไม่ทราบสาเหตุ",
  noResults: "ไม่พบผลลัพธ์",
  
  // Search
  searchPlaceholder: "ค้นหาด้วย SKU หรือชื่อสินค้า...",
  
  // Column headers
  itemCode: "รหัสสินค้า",
  itemName: "ชื่อสินค้า",
  itemGroup: "กลุ่มสินค้า",
  uom: "หน่วย",
  unitOfMeasure: "หน่วยวัด",
  rate: "ราคา",
  standardRate: "ราคามาตรฐาน",
  stockItem: "สินค้าคงคลัง",
  
  // Column placeholders
  searchItemCodes: "ค้นหารหัสสินค้า...",
  searchItemNames: "ค้นหาชื่อสินค้า...",
  selectGroup: "เลือกกลุ่ม...",
  selectUom: "เลือกหน่วย...",
  filterByRate: "กรองตามราคา...",
  select: "เลือก...",
  
  // Values
  yes: "ใช่",
  no: "ไม่",
  
  // Toolbar
  addFilter: "เพิ่มตัวกรอง",
  filters: "ตัวกรอง",
  manageFilters: "จัดการตัวกรอง",
  reset: "รีเซ็ต",
  resetFilters: "รีเซ็ตตัวกรอง",
  view: "มุมมอง",
  viewList: "รายการ",
  viewBoard: "บอร์ด",
  viewTable: "ตาราง",
  viewAdvanced: "ขั้นสูง",
  filter: "ตัวกรอง",
  advanced: "ขั้นสูง",
  toggleColumns: "สลับคอลัมน์",
  searchColumns: "ค้นหาคอลัมน์...",
  noColumnsFound: "ไม่พบคอลัมน์",
  
  // Sort options
  lastUpdatedOn: "อัปเดตล่าสุด",
  createdOn: "สร้างเมื่อ",
  mostUsed: "ใช้บ่อยที่สุด",
  maintainStock: "จัดการสต็อก",
  standardSellingRate: "ราคาขายมาตรฐาน",
  id: "รหัส",
  sortBy: "เรียงตาม",
  sortDescending: "เรียงจากมากไปน้อย",
  sortAscending: "เรียงจากน้อยไปมาก",
  descending: "มากไปน้อย",
  ascending: "น้อยไปมาก",
  
  // Filter modal
  addAndManageFilters: "เพิ่มและจัดการตัวกรองเพื่อปรับแต่งผลการค้นหา",
  applyFilters: "ใช้ตัวกรอง",
  clearFilters: "ล้างตัวกรอง",
  filterBy: "กรองตาม",
  advancedFilters: "ตัวกรองขั้นสูง",
  filterByAssignedCreatedTags: "กรองตามผู้ใช้ที่มอบหมาย ผู้สร้าง และแท็ก",
  assignedTo: "มอบหมายให้",
  assignedToAny: "ใดก็ได้",
  assignedToAll: "ทั้งหมด",
  createdBy: "สร้างโดย",
  tags: "แท็ก",
  selectUser: "เลือกผู้ใช้...",
  enterTagNames: "ป้อนชื่อแท็ก...",
  removeUser: "ลบผู้ใช้",
  removeTag: "ลบแท็ก",
  removeFilter: "ลบตัวกรอง",
  clearAll: "ล้างทั้งหมด",
  loadingTags: "กำลังโหลดแท็ก...",
  noTagsFound: "ไม่พบแท็ก กด Enter หรือ comma เพื่อเพิ่ม",
  startTypingToSearchTags: "เริ่มพิมพ์เพื่อค้นหาแท็ก...",

  // ── Advanced Table View ──────────────────────────────────────────────
  // Filter
  advFilterWhere: "เงื่อนไข",
  advFilterAnd: "และ",
  advFilterAddFilter: "เพิ่มตัวกรอง",
  advFilterClearAll: "ล้างทั้งหมด",
  advFilterNoFilters: "ไม่มีตัวกรอง คลิก \"เพิ่มตัวกรอง\" เพื่อเริ่มต้น",
  advFilterSelectField: "เลือกฟิลด์...",
  advFilterSearchFields: "ค้นหาฟิลด์...",
  advFilterNoFields: "ไม่พบฟิลด์",
  advFilterOperator: "ตัวดำเนินการ...",
  advFilterValue: "ค่า...",
  advFilterSelect: "เลือก...",
  advFilterYes: "ใช่",
  advFilterNo: "ไม่ใช่",
  advFilterMin: "ต่ำสุด",
  advFilterMax: "สูงสุด",

  // Operator labels
  advOpContains: "มีคำว่า",
  advOpIs: "เป็น",
  advOpIsNot: "ไม่เป็น",
  advOpDoesNotContain: "ไม่มีคำว่า",
  advOpIsNotEmpty: "ไม่ว่าง",
  advOpIsEmpty: "ว่าง",
  advOpEquals: "เท่ากับ",
  advOpNotEquals: "ไม่เท่ากับ",
  advOpGreaterThan: "มากกว่า",
  advOpLessThan: "น้อยกว่า",
  advOpGreaterOrEqual: "มากกว่าหรือเท่ากับ",
  advOpLessOrEqual: "น้อยกว่าหรือเท่ากับ",
  advOpBetween: "ระหว่าง",
  advOpAfter: "หลังจาก",
  advOpBefore: "ก่อน",
  advOpIsAnyOf: "เป็นอย่างใดอย่างหนึ่ง",
  advOpIsNoneOf: "ไม่เป็นอย่างใดเลย",

  // Sort
  advSort: "เรียง",
  advSortRules: "กฎการเรียง",
  advSortAdd: "เพิ่มการเรียง",
  advSortClearAll: "ล้างทั้งหมด",
  advSortNoRules: "ไม่มีกฎการเรียง คลิกด้านล่างเพื่อเพิ่ม",
  advSortSelectField: "เลือกฟิลด์",
  advSortAscending: "น้อยไปมาก",
  advSortDescending: "มากไปน้อย",

  // Action bar
  advActionSelected: "รายการที่เลือก",
  advActionSetStatus: "ตั้งสถานะ",
  advActionEnable: "เปิดใช้งาน",
  advActionDisable: "ปิดใช้งาน",
  advActionExportCSV: "ส่งออก CSV",
  advActionArchive: "เก็บถาวร",
  advActionCancel: "ยกเลิก",
  advActionArchiveTitle: "เก็บถาวร",
  advActionArchiveDescription: "รายการจะถูกซ่อนจากรายการที่ใช้งาน แต่สามารถกู้คืนได้",
  advActionArchiveConfirm: "เก็บถาวร",

  // Toast messages
  advToastEnabled: "เปิดใช้งานแล้ว",
  advToastDisabled: "ปิดใช้งานแล้ว",
  advToastArchived: "เก็บถาวรแล้ว",
  advToastFailedUpdate: "ไม่สามารถอัปเดตสถานะได้",
  advToastFailedArchive: "ไม่สามารถเก็บถาวรรายการได้",
  advActionRestore: "กู้คืน",
  advToastRestored: "กู้คืนแล้ว",
  advToastFailedRestore: "ไม่สามารถกู้คืนรายการได้",
  advToastPartialFail: "รายการไม่สามารถอัปเดตได้",

  // Empty state
  advEmptyTitle: "ไม่พบรายการ",
  advEmptyDescription: "ลองปรับตัวกรองหรือคำค้นหาของคุณ",

  // Column visibility
  advColumns: "คอลัมน์",
  advColumnsSearch: "ค้นหาคอลัมน์...",
  advColumnsEmpty: "ไม่พบคอลัมน์",

  // Toolbar
  advFilters: "ตัวกรอง",

  // Data Grid — Edit mode
  dgEditBanner: "โหมดแก้ไข — การเปลี่ยนแปลงจะบันทึกอัตโนมัติ",
  dgToggleEditMode: "เปิด/ปิดโหมดแก้ไข",

  // Data Grid — Context menu
  dgCopy: "คัดลอก",
  dgPaste: "วาง",
  dgClearCell: "ล้างเซลล์",
  dgViewDetail: "ดูรายละเอียด",

  // Data Grid — Paste dialog
  dgPasteTitle: "วางค่า",
  dgPasteDescription: "ตรวจสอบการเปลี่ยนแปลงก่อนนำไปใช้",
  dgPasteCurrent: "ปัจจุบัน",
  dgPasteNew: "ใหม่",
  dgPasteMore: "เพิ่มเติม",
  dgPasteSaving: "กำลังบันทึก",
  dgPasteApply: "นำไปใช้",
  dgPasteSavingBtn: "กำลังบันทึก...",
  dgCancel: "ยกเลิก",

  // Data Grid — Conflict
  dgConflictTooltip: "ถูกแก้ไขโดยผู้ใช้คนอื่น",

  // Data Grid — Keyboard help
  dgKeyboardHelp: "คีย์ลัด",
  dgNavigation: "การนำทาง",
  dgEditing: "การแก้ไข",
  dgClipboard: "คลิปบอร์ด",
  dgUndoRedo: "เลิกทำ / ทำซ้ำ",
  dgShortcutTab: "เซลล์ถัดไป / ก่อนหน้า",
  dgShortcutEnter: "เลื่อนลง",
  dgShortcutEscape: "ยกเลิกการแก้ไข",
  dgShortcutArrows: "นำทางเซลล์",
  dgShortcutHome: "เซลล์แรกในแถว",
  dgShortcutEnd: "เซลล์สุดท้ายในแถว",
  dgShortcutCtrlHome: "เซลล์แรกในตาราง",
  dgShortcutCtrlEnd: "เซลล์สุดท้ายในตาราง",
  dgShortcutPageUp: "เลื่อนขึ้นหนึ่งหน้า",
  dgShortcutPageDown: "เลื่อนลงหนึ่งหน้า",
  dgShortcutCtrlZ: "เลิกทำ",
  dgShortcutCtrlShiftZ: "ทำซ้ำ",
  dgShortcutCtrlC: "คัดลอกเซลล์",
  dgShortcutCtrlV: "วาง",
  dgShortcutCtrlX: "ตัดเซลล์",
  dgShortcutQuestion: "แสดงคีย์ลัด",

  // ── Promotions (PricingCard / PromotionPill) ─────────────────────────
  promoPromotions: "โปรโมชัน",
  promoActions: "จัดการโปรโมชัน",
  promoEndConfirmation: "ยุติโปรโมชันนี้ทันที? ลูกค้าจะเห็นราคาเดิม",
  promoEndSale: "ยุติโปรโมชัน",
  promoKeepIt: "เก็บไว้",
  promoHideBadge: "ซ่อนป้ายบนหน้าร้าน",
  promoShowBadge: "แสดงป้ายบนหน้าร้าน",
  promoDisableStorefront: "ปิดใช้บนหน้าร้าน",
  promoEnableStorefront: "เปิดใช้บนหน้าร้าน",
  promoEditPromotion: "แก้ไขโปรโมชัน",
  promoEndNow: "ยุติทันที",
  promoEnds: "สิ้นสุด",
  promoFrom: "เริ่ม",
  promoScopeItem: "เฉพาะสินค้านี้",
  promoScopeVariants: "ทุกตัวเลือกของสินค้า",
  promoScopeCategory: "หมวดหมู่:",
  promoScopeBrand: "แบรนด์:",
  promoScopeStore: "สินค้าทั้งหมดในร้าน",
  promoEnabled: "เปิดใช้งาน",
  promoDisabled: "ปิดใช้งาน",

  // ── PricingCard ────────────────────────────────────────────────────────
  pricingSellingPrice: "ราคาขาย",
  pricingRunASale: "จัดโปรโมชัน",
  pricingTemplateMessage: "สินค้านี้เป็นสินค้าต้นแบบ ตั้งราคาที่ตัวเลือกสินค้าแต่ละรายการ",
  pricingHowMuch: "คุณต้องการขายในราคาเท่าไร?",
  pricingStorefrontNote: "ราคานี้จะแสดงบนหน้าร้านของคุณ",
  pricingSetSellingPrice: "ตั้งราคาขาย",
  pricingSavingItem: "กำลังบันทึก…",
  pricingSelectUnitFirst: "กรุณาเลือกหน่วยสินค้าก่อน",
  pricingUnitRequired: "ต้องระบุหน่วยสินค้าก่อนตั้งราคา",
  pricingCouldNotSave: "ไม่สามารถบันทึกสินค้าได้",
  pricingFillRequired: "กรอกข้อมูลที่จำเป็นแล้วลองอีกครั้ง",
  pricingNoPricing: "ยังไม่ได้ตั้งราคา",
  pricingAddPriceListToStart: "เพิ่มรายการราคาเพื่อเริ่มต้น",
  pricingCouldNotLoad: "ไม่สามารถโหลดข้อมูลราคาได้",
  pricingRetry: "ลองอีกครั้ง",
  pricingUpdatedTo: "อัปเดตราคาเป็น",
  pricingUndo: "เลิกทำ",
  pricingRevertedTo: "คืนราคาเป็น",
  pricingUndoFailed: "ไม่สามารถเลิกทำได้ กรุณาแก้ไขราคาด้วยตนเอง",
  pricingPromoEnded: "ยุติโปรโมชันแล้ว",
  pricingPromoEndFailed: "ไม่สามารถยุติโปรโมชันได้",
  pricingAddPriceList: "+ เพิ่มรายการราคา",
  pricingPreviewAs: "ดูในมุมมอง:",

  // ── PricingRow ─────────────────────────────────────────────────────────
  pricingBase: "ราคาตั้ง",
  pricingCustomerPays: "ลูกค้าจ่าย",
  pricingAppliedRule: "กฎที่ใช้",
  pricingOtherRules: "กฎอื่นที่ใช้งานอยู่ในรายการราคานี้",
  pricingNotAppliedLower: "ไม่ถูกใช้ — ลำดับความสำคัญต่ำกว่า",
  pricingNotAppliedOverride: "ไม่ถูกใช้ — หน้าร้านกำหนดเอง",
  pricingSetPrice: "ตั้งราคาขาย",
  pricingAddBasePrice: "เพิ่มราคาตั้งสำหรับหน้าร้านของคุณ",
  pricingPrimaryOnShop: "หลัก · บนร้านค้า",
  pricingInternal: "ภายใน",
  pricingSave: "ประหยัด",
} as const;

